import { Empty } from '@maxtropy/components';
import { Spin } from 'antd';
import { isNil } from 'lodash-es';
import { FC, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { CabinetListCircuitWithDataItem } from '../../utils';

export interface ICircuitTabContentProps {
  circuitList?: CabinetListCircuitWithDataItem[];
}

const CircuitTabContent: FC<ICircuitTabContentProps> = props => {
  const { circuitList } = props;
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    if (circuitList && circuitList.length) {
      setLoading(false);
    }
  }, [circuitList]);

  return (
    <>
      {circuitList && circuitList?.length ? (
        <Spin spinning={loading}>
          <div className={styles.cabinetList}>
            {circuitList?.map(item => (
              <div className={styles.cabinetBox} key={item.circuitId}>
                <div className={styles.innerBox}>
                  <div className={styles.nameTxt}>{item.circuitName}</div>
                  <div className={styles.bottomContent}>
                    <div style={{ color: '#FF4D4F', fontSize: '14px' }}>
                      {!isNil(item.electricity) ? item.electricity.toFixed(2) : '--'}kWh
                    </div>
                    <div style={{ marginTop: 8, color: '#52E7FF', fontSize: '14px' }}>
                      {!isNil(item.activePower) ? item.activePower.toFixed(2) : '--'}kW
                    </div>
                  </div>
                  <div className={styles.LeftBlueBorder}></div>
                  <div className={styles.rightBlueBorder}></div>
                </div>
              </div>
            ))}
          </div>
        </Spin>
      ) : (
        <Empty description="该配电柜下暂无回路" />
      )}
    </>
  );
};

export default CircuitTabContent;
